import { ContentMarketersPageLayout } from "../../pagelayouts/use-case/content-marketers";
import { useMarketingPagesTracking } from "../../hooks/marketingPagesTracking";
import { GoogleTagManagerScript } from "../../tracking/GoogleTagManager/GoogleTagManagerScript";

const ContentMarketers = () => {
    useMarketingPagesTracking(true);

    return (
        <>
            <GoogleTagManagerScript />
            <ContentMarketersPageLayout />
        </>
    );
};

export async function getStaticProps() {
    return {
        props: {}
    };
}

export default ContentMarketers;
